import React, {FC, useEffect, useState} from "react";
import {
  Container,
  WrapperRow,
  Title,
  HideWrapper,
  BlueText,
  LeftSide,
  BodyText,
  BodyLink,
  QuotasContainer,
  StateWrapper,
  GreenDot,
  Greentext
} from '../Instances/styles'
import { Diagrams } from "../../HomePage/components";
import { useTranslation } from "react-i18next";
import { icons } from "../../../icons";
import StyledIcon from "../../../components/styled-icon";
import { Button, ModalVariables, StartPage, Table, TutorialVodeo } from "../../../components";
import TutorImg from './illustration.svg'
import TutorDarkImg from './illustration-dark.svg'
import { useTheme } from "styled-components";
import { useNavigate } from "react-router";
import { useUi } from "../../../context/ui.context";
import { useAuth } from "../../../context/user.context";
import { NumberParam, StringParam, useQueryParam } from "use-query-params";
import { compareArrays } from "../../../utils/findIntersection";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import rootConfig from "../../../config";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
import { flavorService } from "../../../api";

const FlavorGroups:FC = () => {
  const [flavorGroups, setFlavorGroups] = useState<any[]>([])
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [searchString, setSearchString] = useQueryParam('search', StringParam);
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [paginationData, setPaginationData] = useState<any>()
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [deletedFlavorGroup, setDeletedFlavorGroup] = useState<any>()
  const [allChecked, setAllChecked] = useState<boolean>(false)
  const [checked, setChecked] = useState<any[]>([])
  const {
    viewAlert,
  } = useUi()
  const {user, quotas} = useAuth()
  const editChecked = (id:any, isAll?:boolean) => {
    if(id === null) {
      setChecked([])
      setAllChecked(false)
      return
    }
    const founded = checked.find((item:any) => item.id === id?.id)
    if(founded) {
      if(isAll){ 
        return 
      } else {
        setChecked((prev:any) => {
          return prev.filter((item:any) => item.id !== id?.id)
        })
        setAllChecked(false)
      }
    } else {
      setChecked((prev) => [...prev, id])
    }
  } 
  useEffect(() => {
    if(compareArrays(flavorGroups, checked) && checked?.length !== 0){
      setAllChecked(true)
    }
  },[checked])
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const {setDataToLs} = useLocalStorage()
  const [t] = useTranslation()
  const navigate = useNavigate()
  const theme:any = useTheme()


  const _updateFlavorGroups = () => {
    // setLoading(true)
    flavorService.getFlavorGroups({
      page:page || 1,
      pageSize:pageSize || 10,
      ordering:ordering,
      search:searchString||''
    })
    .then((res) => {
      setFlavorGroups(res.data.objects.map((group:any) => {
        return {
          ...group,
          navigate: `/openstack/flavor-groups/${group.id}`,
          name: group.name || group.id,
          flavor_count: group.flavor_count || 0,
          is_default: group.is_default ? `${t("YES")}` : `${t("NO")}`,
          selected_by_default: group.selected_by_default ? `${t("YES")}` : `${t("NO")}`,
          created_at: timeConverterMMDDYYHHMM(group.created_at),
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
    })
    .catch((e) => {
      viewAlert({
        severity:'error',
        message:e?.response?.data?.detail || `${t("ERROR_OCCURRED")}`,
      })
      navigate('/home')
      setPageLoading(false)
    })
  }
  useEffect(() => {
    _updateFlavorGroups()
    const interval = setInterval(() => {
      _updateFlavorGroups()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,
    searchString])

  const items = [
    {
      title:t("EDIT"),
      id:'3',
      icon:icons.Edit,
      onClick: (group:any) => {
        navigate(`/openstack/flavor-groups/${group.id}/edit`)
      },
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      onClick:(group:any) => {
        openModal('delete')
        setAlertTitle(t("FLAVOR_GROUP"))
        setAlertSubTitle([group])
        setDeletedFlavorGroup(group)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]

  const Columns = [
    {
      title:t("NAME"),
      key:'name',
    },
    {
      title:t("DESCRIPTION"),
      key:'description'
    },
    {
      title:t("FLAVOR_COUNT"),
      key:'flavor_count'
    },
    {
      title:t("PRIORITY"),
      key:'priority'
    },
    {
      title:t("IS_DEFAULT"),
      key:'is_default'
    },
    {
      title:t("SELECTED_BY_DEFAULT"),
      key:'selected_by_default'
    },
    {
      title:t("CREATED_AT"),
      key:'created_at'
    },
    {
      title:'',
      key:'props'
    },
  ]

  const _deleteFlavorGroups = async () => {
    setLoading(true)
    try{
      if(allChecked) {
        let promises:any[] = []
        await flavorGroups.map(async(item:any) => {
          let promise = await flavorService.deleteFlavorGroup(item.id)
          await promises.push(promise)
        })
        await Promise.all(promises)
        await _updateFlavorGroups()
        await setAllChecked(false)
      } else if (checked?.length > 0){
        let promises:any[] = []
        await checked.map((item:any) => {
          let promise = flavorService.deleteFlavorGroup(item.id)
          promises.push(promise)
        })
        await Promise.all(promises)
        await _updateFlavorGroups()
        await setChecked([])
      } else if (deletedFlavorGroup) {
        await flavorService.deleteFlavorGroup(deletedFlavorGroup.id)
        await _updateFlavorGroups()
      }
    } catch (e:any) {
      if(e?.response?.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      }
      _updateFlavorGroups()
      setPageLoading(false)
    } finally {
      setViewModal(false)
      setActiveAnimation(false)
      setLoading(false)
    }
  }

  const closeModal = (props:any) => {
    if(modalType === 'delete'){
      _deleteFlavorGroups()
    }
  }

  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
    setDeletedFlavorGroup(null)
  }


  const _createFunc = () => {
    navigate('/openstack/flavor-groups/create')
  }
  return (
    <>
      <StartPage
        title={`${t("FLAVOR_GROUPS")}`}
        noResourceText={`${t("NO_FLAVOR_GROUPS")}`}
        createResourceButton={`${t('CREATE_FLAVOR_GROUP')}`}
        createResourceButtonEventOrLink={_createFunc}
        haveResource={flavorGroups.length > 0}
        learnMoreAboutResource={`${t('LEARN_MORE_FLAVOR_GROUPS')}`}
        howCreateVideoText={`${t('HOW_CREATE_FLAVOR_GROUP')}`}
        learnMoreAboutResourceLink={`${rootConfig.docs_url}category/flavor-groups`}
        rightButtonComponentCustomWithResources={
          <div style={{display:'flex', alignItems:'center'}}>
            <Button
              onClick={() => {
                setAlertTitle(t("FLAVOR_GROUPS"))
                setAlertSubTitle(allChecked ? flavorGroups : checked)
                openModal('delete')
              }}
              variant='icon'
              size='display'
              test_id='button-delete'
              disabled={!allChecked && checked?.length === 0 }
              customStyles={{margin:'0px 6px 0px 0px'}}
            >
              <img src={icons.DeleteIcon}/>
            </Button>
          </div>
        }
        videoImage={TutorImg}
        videoImageDark={TutorDarkImg}
        pageLoading={pageLoading}
        tableData={{
          columns:Columns,
          data:flavorGroups,
          props:items,
          allChecked:allChecked,
          setAllChecked:setAllChecked,
          checked:checked,
          setChecked:editChecked,
          paginationData:paginationData,
          updateData:_updateFlavorGroups
        }}
      />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
        instance={deletedFlavorGroup}
      />
    </>
  )
}


export default FlavorGroups
